// extracted by mini-css-extract-plugin
export default {"errorContainer":"style_errorContainer__jVh2u","errorMessage":"style_errorMessage__ZlBuB","errorHeading":"style_errorHeading__HSusC","errorList":"style_errorList__5DfKT"};